var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"omni-chart","data-chart":_vm.widgetConfig.key,"data-id":_vm.widgetConfig.key,"data-color":_vm.widgetConfig.color,"data-font":_vm.widgetConfig.font,"data-endpoint":_vm.widgetConfig.url}})}
var staticRenderFns = []

export { render, staticRenderFns }